import RiderServices from "../../services/externalServices/riders/RiderServices";
const releaseRidersFromBidLock = async (phoneNumbers) => {
  console.log("Phone numbers to be unlocked: ", phoneNumbers);

  // if (!Array.isArray(phoneNumbers) || phoneNumbers.length === 0) {
  //   console.error("Invalid input: phoneNumbers must be a non-empty array.");
  //   return;
  // }

  // let  results = [];

  // Ensure phoneNumbers is always an array
  if (!Array.isArray(phoneNumbers)) {
    phoneNumbers = [phoneNumbers]; // Convert to array if it's a single number
  }

  if (phoneNumbers.length === 0) {
    console.error("Invalid input: phoneNumbers must be a non-empty array.");
    return;
  }
  let results = [];
  for (const phone_number of phoneNumbers) {
    try {
      // Payload for the API call
      const payload = { phone_number, bidInProgress: false };

      console.log("Updating rider:", payload);

      // Call the API for each phone number
      const response = await RiderServices.updateRiderByPhoneNumber(payload);

      // Collect the result for logging or further processing
      results.push({
        phone_number,
        success: true,
        data: response.data,
      });

      console.log(
        `Successfully updated rider with phone number: ${phone_number}`
      );
    } catch (error) {
      console.error(
        `Failed to update rider with phone number: ${phone_number}`,
        error
      );

      // Collect the failure result
      results.push({
        phone_number,
        success: false,
        error: error.message || "Unknown error occurred",
      });
    }
  }

  // Log the overall results or return them for further use
  console.log("Update results:", results);

  return results;
};

export default releaseRidersFromBidLock;

export const updateRider = async (phoneNumber, input) => {
  let results = [];
  console.log("Updating rider", updateRider);

  if (phoneNumber === "") {
    console.error("Invalid input: phoneNumber is empty.");
    return;
  }

  try {
    // Payload for the API call
    const payload = { phoneNumber, input };

    console.log("Updating rider:", payload);

    // Call the API for each phone number
    const response = await RiderServices.updateRiderByPhoneNumber(payload);

    console.log(`Successfully updated rider with phone number: ${phoneNumber}`);
  } catch (error) {
    console.error(
      `Failed to update rider with phone number: ${phoneNumber}`,
      error
    );
  }

  // Log the overall results or return them for further use
  console.log("Update results:", results);

  return results;
};
